import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendNode, OdataOperation, OdataService } from '@mono-repo/odata';

interface IPingStatus {
  available: boolean;
  planned: boolean;
  text: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppGuard implements CanActivate {
  constructor(
    private readonly odataService: OdataService,
    private router: Router,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.odataService
      .get<IPingStatus>(new OdataOperation().Query('pingbackenddt'), { backendNode: BackendNode.PUBLIC })
      .pipe(
        map((response) =>
          response.available ? true : (
            this.router.parseUrl(`/serviceNotAvailable?message=${response.planned ? response.text : ''}`)
          ),
        ),
      );
  }
}
